const addNotifiedThryvUser = async ({ commit }, { sub }) => {
    commit('ADD_NOTIFIED_THRYV_USER', { sub });
};

export default {
    ADD_NOTIFIED_THRYV_USER(context, payload) {
        return addNotifiedThryvUser(context, payload);
    },
};
